import { useEffect } from 'react';
export var useFileViewerKeyboardListener = function (previousPage, nextPage, disabledShortcuts) {
    var handleKeyDown = function (event) {
        switch (event.key) {
            case 'ArrowLeft': {
                return previousPage();
            }
            case 'ArrowRight': {
                return nextPage();
            }
        }
    };
    useEffect(function () {
        // don't disable default shortcuts
        if (!disabledShortcuts) {
            document.addEventListener('keydown', handleKeyDown);
            return function () {
                document.removeEventListener('keydown', handleKeyDown);
            };
        }
    });
};
